export default {
  customized: {
    label: 'Customized Images & Videos',
    filter: {
      network: {
        massive: 'Ocean Engine (Toutiao, Pangle, Tiktok)',
        engine: 'Toutiao',
        tencent: 'Tencent Ads',
        baidu: 'Baidu',
        kuaishou: 'Kuaishou',
        wifi: 'Wifi Master Key',
        fan: 'Fan Pass',
        wechat: 'Wechat',
        mostright: 'Zui You',
        other: 'Others',
      },
    },
    describe:
      'We Provide High-Quality Creative Customization And Diversified Marketing Planning Services To Meet Your Different Marketing Goals And Scenarios.',
    table: {
      operation: {
        applytips: 'Apply App',
      },
    },
  },
}
